import Service from '../service';

export default class ProfileService extends Service {
  baseApi = '/user/profile';

  async getProfile(query) {
    const url = `${this.baseApi}`;
    return await this.getResource(url, query);
  }

  async updateUserProfile(data) {
    const url = `${this.baseApi}/user`;
    return await this.postResource(url, data);
  }

  async updateAdminProfile(data) {
    const url = `${this.baseApi}/admin`;
    return await this.postResource(url, data);
  }

  async updateManagerProfile(data) {
    const url = `${this.baseApi}/manager`;
    return await this.postResource(url, data);
  }
}
